// ---------------------------------------------------------------------------
// Digital Notice Board — DesignerToolbar (top bar of the studio)
// ---------------------------------------------------------------------------
// Board-level actions: rename, change the screen shape/resolution, undo/redo,
// save, and launch the projection. Presentational — it only raises callbacks.
// ---------------------------------------------------------------------------
import React from "react";
import {Button, Flex, HStack, IconButton, Input, Select, Tooltip, useColorModeValue} from "@chakra-ui/react";
import {FaArrowLeft, FaPlay, FaRedo, FaSave, FaUndo} from "react-icons/fa";
import {CANVAS_PRESETS} from "../constants/NoticeBoardConstants";

export default function DesignerToolbar({
    name,
    presetId,
    canUndo,
    canRedo,
    saving,
    onBack,
    onNameChange,
    onPresetChange,
    onUndo,
    onRedo,
    onSave,
    onProject,
}) {
    const border = useColorModeValue("gray.200", "gray.600");
    return (
        <Flex
            justify="space-between"
            align="center"
            wrap="wrap"
            gap="10px"
            mb="16px"
            pb="12px"
            borderBottom="1px solid"
            borderColor={border}
        >
            <HStack spacing="10px" flex="1" minW="240px">
                <IconButton size="sm" variant="ghost" aria-label="Back" icon={<FaArrowLeft />} onClick={onBack} />
                <Input
                    size="sm"
                    fontWeight="bold"
                    maxW="280px"
                    value={name}
                    onChange={(e) => onNameChange(e.target.value)}
                    placeholder="Board name"
                />
                <Select size="sm" maxW="230px" value={presetId} onChange={(e) => onPresetChange(e.target.value)}>
                    {CANVAS_PRESETS.map((p) => (
                        <option key={p.id} value={p.id}>{p.label}</option>
                    ))}
                </Select>
            </HStack>

            <HStack spacing="8px">
                <Tooltip label="Undo">
                    <IconButton size="sm" variant="outline" aria-label="Undo" icon={<FaUndo />} isDisabled={!canUndo} onClick={onUndo} />
                </Tooltip>
                <Tooltip label="Redo">
                    <IconButton size="sm" variant="outline" aria-label="Redo" icon={<FaRedo />} isDisabled={!canRedo} onClick={onRedo} />
                </Tooltip>
                <Button size="sm" leftIcon={<FaSave />} variant="outline" colorScheme="blue" isLoading={saving} onClick={onSave}>
                    Save
                </Button>
                <Button size="sm" leftIcon={<FaPlay />} colorScheme="green" onClick={onProject}>
                    Project
                </Button>
            </HStack>
        </Flex>
    );
}
